(() => {
  if (window.RanivaaCartFeedback) return;
  const cartLink = () => document.querySelector('.rv-actions a[aria-label="Cart"]');
  function capture(button) {
    const card = button.closest('.rv-product-card,.rv-smart-card,.rv-related__card,.rv-rec-card,product-card,.product-card');
    const product = button.closest('.rv-product');
    const images = card ? [...card.querySelectorAll('img')] : product ? [...product.querySelectorAll('.rv-gallery__slide:not([hidden]) img,.rv-product__media img')] : [];
    const visible = images.map(image => ({image, rect: image.getBoundingClientRect()})).filter(({rect}) => rect.width && rect.height && rect.bottom > 0 && rect.top < innerHeight);
    const chosen = visible.sort((a, b) => Math.min(b.rect.right, innerWidth) - Math.max(b.rect.left, 0) - (Math.min(a.rect.right, innerWidth) - Math.max(a.rect.left, 0)))[0];
    const image = chosen?.image || images[0];
    if (!image) return null;
    const rect = chosen?.rect || button.getBoundingClientRect();
    return {src: image.currentSrc || image.src, rect: {left: rect.left, top: rect.top, width: rect.width, height: rect.height}};
  }
  function fly(source) {
    const destination = cartLink();
    if (!source?.src || !destination || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const end = destination.getBoundingClientRect();
    if (!end.width || !end.height || end.bottom < 0 || end.top > innerHeight) return;
    const size = Math.min(150, Math.max(60, source.rect.width));
    const x = Math.min(innerWidth - size, Math.max(0, source.rect.left + source.rect.width / 2 - size / 2));
    const y = Math.min(innerHeight - size, Math.max(0, source.rect.top + source.rect.height / 2 - size / 2));
    const dx = end.left + end.width / 2 - x - size / 2;
    const dy = end.top + end.height / 2 - y - size / 2;
    const image = document.createElement('img');
    image.className = 'rv-cart-flight';
    image.src = source.src;
    image.alt = '';
    image.setAttribute('aria-hidden', 'true');
    image.style.cssText = `position:fixed;left:${x}px;top:${y}px;width:${size}px;height:${size}px;object-fit:contain;border-radius:12px;background:#fff;opacity:.7;pointer-events:none;z-index:2147483646;will-change:transform,opacity;`;
    document.body.appendChild(image);
    if (!image.animate) { image.remove(); return; }
    const animation = image.animate([
      {transform: 'translate(0,0) scale(1)', opacity: .7},
      {transform: `translate(${dx * .45}px,${dy * .5 - 45}px) scale(.6)`, opacity: .5, offset: .5},
      {transform: `translate(${dx}px,${dy}px) scale(.08)`, opacity: .05}
    ], {duration: 1100, easing: 'cubic-bezier(.25,.65,.35,1)', fill: 'forwards'});
    animation.finished.then(() => image.remove(), () => image.remove());
    destination.animate?.([{transform:'scale(1)'},{transform:'scale(1.15)'},{transform:'scale(1)'}], {duration:360,delay:900});
  }
  function success(source, quantity = 1) {
    document.dispatchEvent(new CustomEvent('rv:cart-add-success', {detail: {quantity: Math.max(1, Number(quantity) || 1)}}));
    fly(source);
  }
  window.RanivaaCartFeedback = {capture, success};
})();